var _path, _mask, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcRewardsManager(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 0C194.035 0 250 55.965 250 125C250 194.035 194.035 250 125 250C55.965 250 0 194.035 0 125C0 55.965 55.965 0 125 0Z",
    fill: "#D9F4F8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 250,
    height: 250
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125 0C194.035 0 250 55.965 250 125C250 194.035 194.035 250 125 250C55.965 250 0 194.035 0 125C0 55.965 55.965 0 125 0Z",
    fill: "#D9F4F8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.927,
    y: 85.2485,
    width: 105.722,
    height: 143.962,
    rx: 5.99842,
    transform: "rotate(12.225 138.927 85.2485)",
    fill: "#D5D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.133 140.514L143.751 151.506L148.148 152.458L141.321 183.969L197.746 196.194L204.574 164.684L208.964 165.635L211.352 154.644L146.133 140.514Z",
    fill: "#8E44AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.52 138.628C200.936 140.089 199.507 141.603 197.495 142.878C194.771 144.644 188.981 145.633 184.896 145.51C186.188 141.866 188.486 136.333 191.87 134.179C194.229 132.667 196.461 132.038 198.147 132.403C199.254 132.643 200.166 133.337 200.939 134.525C201.861 135.968 202.042 137.271 201.52 138.628ZM162.879 131.843C161.573 129.841 160.909 127.877 161.002 126.308C161.065 124.851 161.766 123.75 163.21 122.818C164.401 122.048 165.52 121.802 166.63 122.043C168.307 122.406 170.088 123.897 171.611 126.249C173.792 129.634 174.536 136.158 174.238 139.831C170.386 138.459 164.799 134.822 162.879 131.843ZM206.771 130.795C202.857 124.73 195.338 123.726 188.107 128.36C185.085 130.289 182.867 133.418 181.19 136.579C180.984 131.54 179.656 125.946 177.439 122.506C172.765 115.292 165.514 113.09 159.452 116.999C156.086 119.144 154.237 122.244 154.048 125.963C153.898 129.004 154.937 132.333 157.038 135.582C158.187 137.349 159.955 139.1 161.974 140.707L162.265 140.94L200.34 149.19L200.586 149.073C200.814 148.943 201.059 148.833 201.276 148.702C204.527 146.61 206.848 144.009 207.97 141.176C209.346 137.716 208.935 134.125 206.771 130.795Z",
    fill: "#8E44AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.503 189.208L175.762 191.431L185.289 147.463L175.03 145.24L165.503 189.208Z",
    fill: "#5A2C6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.133 140.514L211.352 154.644L211.987 151.713L146.768 137.583L146.133 140.514Z",
    fill: "#481E58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.574 164.684L148.148 152.458L147.195 156.855L203.621 169.081L204.571 164.696L204.574 164.684Z",
    fill: "#5A2C6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.59 159.921L172.33 157.698L171.378 162.095L181.637 164.317L182.587 159.933L182.59 159.921Z",
    fill: "#481E58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.88049,
    y: 94.1361,
    width: 108.4,
    height: 147.609,
    rx: 6.15037,
    transform: "rotate(-12.2379 8.88049 94.1361)",
    fill: "#E1E3E3"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0709 142.655L41.5154 153.925L46.0233 152.947L53.0307 185.254L110.883 172.706L103.875 140.399L108.377 139.423L105.939 128.151L39.0709 142.655Z",
    fill: "#8E44AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9626 117.378C90.0381 118.989 89.3464 121.009 88.0106 123.053C86.2182 125.859 81.2338 129.239 77.3698 130.859C77.0279 126.91 76.824 120.77 79.0675 117.323C80.6265 114.91 82.4429 113.376 84.1714 113.001C85.3062 112.755 86.452 113.015 87.6779 113.796C89.1518 114.751 89.8731 115.89 89.9626 117.378ZM51.0182 127.453C48.9495 126.138 47.4965 124.587 46.9165 123.084C46.3569 121.697 46.5438 120.372 47.4953 118.889C48.2798 117.664 49.2198 116.96 50.3583 116.713C52.0778 116.34 54.3725 116.975 56.7929 118.524C60.2654 120.757 63.7299 126.529 65.0115 130.085C60.8337 130.44 54.0754 129.417 51.0182 127.453ZM91.5372 107.838C85.3093 103.839 77.866 106.095 73.0844 113.49C71.0829 116.573 70.3418 120.436 70.119 124.098C67.7873 119.482 64.1727 114.825 60.6423 112.556C53.2172 107.808 45.5153 108.831 41.5175 115.053C39.2869 118.484 38.877 122.163 40.2801 125.714C41.4318 128.616 43.8145 131.282 47.1548 133.422C48.9768 134.583 51.3704 135.467 53.9381 136.109L54.3078 136.203L93.3457 127.736L93.526 127.523C93.6835 127.304 93.8653 127.098 94.0125 126.883C96.1582 123.55 97.2201 120.137 97.0637 117.017C96.8791 113.204 94.9714 110.027 91.5372 107.838Z",
    fill: "#8E44AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8245 179.876L88.3431 177.595L78.5653 132.515L68.0468 134.797L77.8245 179.876Z",
    fill: "#5A2C6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0709 142.655L105.939 128.151L105.287 125.146L38.4191 139.65L39.0709 142.655Z",
    fill: "#481E58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.875 140.399L46.0233 152.947L47.0011 157.455L104.853 144.907L103.878 140.412L103.875 140.399Z",
    fill: "#5A2C6D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3357 145.288L70.8171 147.569L71.7949 152.077L82.3135 149.796L81.3385 145.301L81.3357 145.288Z",
    fill: "#481E58"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 36,
    width: 125,
    height: 218,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 106V121H89V164H166V121H171.991L172 106H83Z",
    fill: "#8E44AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.662 87.9003C154.313 89.9694 152.877 92.346 150.616 94.5758C147.563 97.6483 140.295 100.571 134.937 101.565C135.591 96.4512 137.025 88.5901 140.827 84.8263C143.474 82.1889 146.206 80.7393 148.507 80.7393C150.017 80.7393 151.402 81.3866 152.745 82.7168C154.355 84.3372 154.958 85.9836 154.662 87.9003ZM102.379 89.9694C100.111 87.7283 98.6919 85.3557 98.3691 83.285C98.0402 81.3672 98.6432 79.7344 100.262 78.1116C101.596 76.7717 102.985 76.1356 104.501 76.1356C106.789 76.1356 109.531 77.5755 112.181 80.2114C115.979 84.0073 118.792 92.3005 119.441 97.1731C114.032 96.473 105.723 93.309 102.379 89.9694ZM159.294 76.2074C152.479 69.4072 142.396 70.222 134.278 78.3045C130.884 81.6719 128.877 86.3772 127.584 90.9712C125.893 84.4606 122.582 77.5449 118.72 73.6868C110.59 65.604 100.518 64.7808 93.7202 71.5883C89.9388 75.3345 88.4034 79.8978 89.2079 84.7987C89.8718 88.805 92.1656 92.8505 95.8216 96.4924C97.8176 98.4703 100.617 100.254 103.703 101.778L104.147 102H156.106L156.394 101.778C156.655 101.544 156.943 101.332 157.189 101.099C160.836 97.4545 163.126 93.409 163.788 89.3996C164.604 84.5018 163.055 79.937 159.294 76.2074Z",
    fill: "#9654B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122 164H136V104H122V164Z",
    fill: "#633874"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83 106H172V102H83V106Z",
    fill: "#633874"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166 121H89V127H166V121.017V121Z",
    fill: "#673E79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136 121H122V127H136V121.017V121Z",
    fill: "#3E2A46"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 201,
    r: 16,
    stroke: "#13C1BF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 202.516H128.768V208H125.204V202.516H120V199.457H125.204V194H128.768V199.457H134V202.516Z",
    fill: "#13C1BF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRewardsManager);
export default __webpack_public_path__ + "static/media/ic_rewardsManager.c0ebf169f5bff059eb96f8ee09047e30.svg";
export { ForwardRef as ReactComponent };